/**
 * Hook to check if a user has a specific feature enabled
 * @param {string} featureName - The name of the feature to check
 * @returns {boolean} - Whether the user has the feature enabled
 */
export default function useUserHasFeature(featureName: string): boolean {
    const user = window.gon.currentUser
    return user?.features?.some((f: { name: string }) => f.name === featureName) ?? false
}
